/**
 * @fileoverview CompTimeWarningPrompt Component for Clockwise CPA
 *
 * Shows a warning modal when user logs in with 80+ hours of comp time.
 * This prompt appears EVERY login while comp time is at maximum (no permanent dismissal).
 *
 * Key Features:
 * - Shows every login when comp time >= 80 hours
 * - Cannot be permanently dismissed
 * - Provides link to view Leave Bank
 * - Alert-style UI with warning colors
 *
 * @author Clockwise CPA Development Team
 * @version 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import '../styles/CompTimeWarningPrompt.css';

const CompTimeWarningPrompt = ({ compBalance, onClose, isOpen }) => {
  const navigate = useNavigate();

  const handleViewLeaveBank = () => {
    onClose();
    navigate('/leave-bank');
  };

  const handleContinue = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="comptime-prompt-overlay">
      <div className="comptime-prompt-modal">
        <button
          className="comptime-prompt-close"
          onClick={handleContinue}
          aria-label="Close"
        >
          <FiX />
        </button>

        <div className="comptime-prompt-icon">
          <FiAlertTriangle />
        </div>

        <h2 className="comptime-prompt-title">
          Comp Time Bank Full
        </h2>

        <p className="comptime-prompt-description">
          Your comp time bank has reached the maximum of 80 hours. You are currently at <strong>{compBalance.toFixed(1)} hours</strong>.
        </p>

        <div className="comptime-prompt-warning-box">
          <div className="comptime-prompt-warning-item">
            <span className="comptime-prompt-warning-label">Current Balance:</span>
            <span className="comptime-prompt-warning-value">{compBalance.toFixed(1)} hours</span>
          </div>
          <div className="comptime-prompt-warning-item">
            <span className="comptime-prompt-warning-label">Maximum Allowed:</span>
            <span className="comptime-prompt-warning-value">80.0 hours</span>
          </div>
        </div>

        <p className="comptime-prompt-notice">
          Please use some comp time soon. Additional comp time earnings may not accrue while at the maximum.
        </p>

        <div className="comptime-prompt-actions">
          <button
            className="comptime-prompt-primary-btn"
            onClick={handleViewLeaveBank}
          >
            View Leave Bank
          </button>
          <button
            className="comptime-prompt-secondary-btn"
            onClick={handleContinue}
          >
            Continue to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

CompTimeWarningPrompt.propTypes = {
  compBalance: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default CompTimeWarningPrompt;
